export class Owner {
  constructor(
    readonly id: string,
    readonly name: string,
  ) {}
}
